import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ShimanoBusinessTypeService } from '../service/businessType/shimano-business-type.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentBusinessType {
  businessType: string;

  constructor(private shimanoBusinessTypeService: ShimanoBusinessTypeService) {
    this.shimanoBusinessTypeService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (this.businessType = data));
  }

  getBusinessType() {
    return this.businessType;
  }
}
